import s1 from './succulents/Echeveria/1.jpg';
import s2 from './succulents/Echeveria/2.jpg';
import s3 from './succulents/Echeveria/3.jpg';
import s4 from './succulents/Echeveria/4.jpg';
import s5 from './succulents/Echeveria/5.jpg';

let Echeveria = [

    {
        key: 1,
        name: 'ECHEVERIA LOLA',
        img: s1,
        price: 5,
        description: 'It has beautiful pale gray green rosettes and powdery pointed symmetrical leaves.',
        descriptionLong: 'A popular Echeveria species that forms beautiful pale gray green rosettes of powdery pointed symmetrical leaves. The mature tight rosette resembles the look of a rosebud, which is a perfect choice for a gift.',
    },

    {
        key: 2,
        name: 'WOOLLY SENECIO',
        img: s2,
        price: 8,
        description: "Its leaves are fleshy, spike-shaped and covered with a powdery green white layer.",
        descriptionLong: "Commonly known as Woolly Senecio, The Silver Spider, or Silver Coral. Its leaves are fleshy, spike-shaped and covered with a powdery green white layer. This coating serves as a protecting cover for the plant to reflect sunlight and avoid overheating or sunburn.",
    },

    {
        key: 3,
        name: 'CRASSULA HERREI',
        img: s3,
        price: 6,
        description: "A rare low-growing succulent that forms shrubs of thick chubby leaves.",
        descriptionLong: "A rare low-growing succulent that forms shrubs of thick chubby leaves. The foliage's colors range from green to yellow with pink edges depending on sun exposure.",
    },

    {
        key: 4,
        name: 'SENECIO COCOON PLANT',
        img: s4,
        price: 6,
        description: "The white felt covering the surface of its upright cylindrical leaves.",
        descriptionLong: "Native to South Africa, also known as a Wooly Senecio because of the white felt covering the surface of its upright cylindrical leaves. The fuzzy coverage makes Woolly Senecio an extremely intriguing plant and definitely one of the most aesthetically pleasing in its genus.",
    },

    {
        key: 5,
        name: 'ECHEVERIA ELEGANS BLUE',
        img: s5,
        price: 6,
        description: "Has plump, blue-green rounded leaves ending in a point and growing in a tight clump.",
    },
]

export default Echeveria;